import { useContext, PropsWithChildren } from 'react';
import { ModalProps } from './modal';
import { ModalContext } from './modal-context';

/* eslint-disable @typescript-eslint/naming-convention */
export const useModal = (): { Modal: React.FC<PropsWithChildren<ModalProps>> } => {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error('useModal must be used inside a ModalProvider');
  }

  return {
    Modal: context.modalComponent,
  };
};
